import {
  LoadingInTabWrapper,
  MainTabContentWrapper,
  RefreshInTabWrapper,
} from "../../../../style/DashbordWidgetWrappers";
import ResumeInfoClaim from "./components/ResumeInfoClaim";
import { IconLoading } from "../../../../config/icons";
import ClaimDetailsProvider, {
  useClaimDetailsContext,
} from "./ClaimDetailsContext";
import ClaimTabs from "./components/ClaimTabs";

interface IClaimDetailsProps {
  idClaim: number;
  defaultTab?: string;
  defaultTabPanel?: string;
  tabKey: number;
}

const ClaimDetails = ({ idClaim, defaultTab, tabKey }: IClaimDetailsProps) => {
  return (
    <ClaimDetailsProvider idClaim={idClaim}>
      <ClaimDetailsProviderChildren defaultTab={defaultTab} />
    </ClaimDetailsProvider>
  );
};

export default ClaimDetails;

interface IClaimDetailsProviderChildrenProps {
  defaultTab?: string;
}

const ClaimDetailsProviderChildren = ({
  defaultTab,
}: IClaimDetailsProviderChildrenProps) => {
  const { claim, status } = useClaimDetailsContext();

  return (
    <>
      {status == "loading" && (
        <LoadingInTabWrapper>
          <div className="box">{IconLoading}</div>
        </LoadingInTabWrapper>
      )}

      {["idle", "refreshing", "saving"].includes(status as string) && (
        <>
          {claim && (
            <MainTabContentWrapper>
              <ResumeInfoClaim />

              <ClaimTabs />
            </MainTabContentWrapper>
          )}

          {["refreshing", "saving"].includes(status as string) && (
            <RefreshInTabWrapper>
              <div className="box">{IconLoading}</div>
            </RefreshInTabWrapper>
          )}
        </>
      )}
    </>
  );
};
